var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1678_1207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 4V9.33333C18.6665 9.68695 18.807 10.0261 19.057 10.2761C19.3071 10.5262 19.6462 10.6667 19.9998 10.6667H25.3332",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 28H9.33317C8.62593 28 7.94765 27.719 7.44755 27.219C6.94746 26.7189 6.6665 26.0406 6.6665 25.3333V6.66667C6.6665 5.95942 6.94746 5.28115 7.44755 4.78105C7.94765 4.28095 8.62593 4 9.33317 4H18.6665L25.3332 10.6667V16.6667",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 23.3333C18.6665 24.2174 19.0177 25.0652 19.6428 25.6904C20.2679 26.3155 21.1158 26.6667 21.9998 26.6667C22.8839 26.6667 23.7317 26.3155 24.3569 25.6904C24.982 25.0652 25.3332 24.2174 25.3332 23.3333C25.3332 22.4493 24.982 21.6014 24.3569 20.9763C23.7317 20.3512 22.8839 20 21.9998 20C21.1158 20 20.2679 20.3512 19.6428 20.9763C19.0177 21.6014 18.6665 22.4493 18.6665 23.3333Z",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6665 26L27.9998 29.3333",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1678_1207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocSearchIcon);
export default __webpack_public_path__ + "static/media/doc_search_icon.f3e9444df74e09d1c2740029ff8d7325.svg";
export { ForwardRef as ReactComponent };